import {emotionStyled, createVars, tokens} from '@packages/utilities/styled';

export const [cssTokens, setLocalTokens] = createVars({
  margin: tokens.space[2],
});

export const DividerView = emotionStyled('hr')(
  {
    ...cssTokens,
    background: '$border1',
    border: 'none',
  },
  {
    componentName: 'Divider',
    variants: {
      elevation: {
        1: {
          background: '$border1',
        },
        2: {
          background: '$border2',
        },
        3: {
          background: '$border3',
        },
      },
      orientation: {
        horizontal: {
          height: '1px',
          marginLeft: 0,
          marginRight: 0,
          width: '100%',
        },
        vertical: {
          alignSelf: 'stretch',
          marginBottom: 0,
          marginTop: 0,
          width: '1px',
          height: 'auto',
          '&&': {
            boxSizing: 'border-box',
            height: 'auto',
          },
        },
      },
    },
  }
);
